module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "news-top-right.8c732e02.webp" + "?" + Date.now();